const TYPES = ["image/jpeg", "image/png", "image/webp"];
export const BAD_TYPE = "Use a JPG, PNG or WebP image";
export const TOO_BIG = "Image must be 5 MB or smaller";

const loadImg = (file) => new Promise((res, rej) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); res(img); };
  img.onerror = () => { URL.revokeObjectURL(url); rej(new Error("This image can't be read")); };
  img.src = url;
});

export async function resizeImage(file, max = 1200) {
  if (!TYPES.includes(file.type)) throw new Error(BAD_TYPE);
  if (file.size > 5 * 1024 * 1024) throw new Error(TOO_BIG);
  const img = await loadImg(file);
  const k = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * k);
  c.height = Math.round(img.height * k);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  const blob = (t) => new Promise((r) => c.toBlob(r, t, 0.85));
  const webp = await blob("image/webp");
  return webp && webp.type === "image/webp" ? webp : blob("image/jpeg");
}

export async function uploadImage(client, file, path = "/media/upload", params = {}) {
  const b = await resizeImage(file);
  const fd = new FormData();
  fd.append("file", b, b.type === "image/webp" ? "image.webp" : "image.jpg");
  return (await client.post(path, fd, { params })).data.url;
}
